// extracted by mini-css-extract-plugin
export default {"main":"Hero_main__4+pPk","content":"Hero_content__YK9OZ","x":"Hero_x__C5tqv","y":"Hero_y__TKeHK"};